module.exports = __webpack_public_path__ + "static/Android_iOS-Iphone-28135981c53640c822b2882ce88ee7c3.mp4";